import {CPSConstants} from "commonUtils/enumerations";

export const facultyStyle = {
  facultyProfileiframeContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    height: "45rem",
  },
  facultyBoxStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fieldBackgroundColour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFFFFF",
  },
  fieldAlignDOL: {
    verticalAlign: "middle",
  },
  dataGridFacultyTypeStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDataGrid-columnHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
      paddingLeft: "3px",
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      borderRight: "1px solid #a9cb83",
    },
    "& .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.MuiDataGrid-columnHeader--sorted.MuiDataGrid-withBorderColor":
      {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        backgroundColor: "#9dd262",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
          fontWeight: "bold",
        },
      },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {fontFamily: "Montserrat"},
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "flex",
      padding: "2px",
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "bold",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      "& .MuiDataGrid-cell": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        padding: "5px 5px",
        lineHeight: "normal !important",
        whiteSpace: "normal !important",
        wordWrap: "break-word",
      },
    },
  },
  dataGridStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDataGrid-columnHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
      paddingLeft: "3px",
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      borderRight: "1px solid #a9cb83",
    },
    "& .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.MuiDataGrid-columnHeader--sorted.MuiDataGrid-withBorderColor":
      {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        backgroundColor: "#9dd262",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
          fontWeight: "bold",
        },
      },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {fontFamily: "Montserrat"},
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "flex",
      padding: "2px",
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "normal",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      "& .MuiDataGrid-cell": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        padding: "5px 5px",
        lineHeight: "normal !important",
        whiteSpace: "normal !important",
        wordWrap: "break-word",
      },
    },
  },
  paddingLeftTenPixel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "10px",
  },
  facultyBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "15px 10px",
  },
  marginThreePixel: {margin: "0.1rem"},
  topHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
  roleName: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
  },
  cardTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#9dd262",
    padding: "5px 5px",
    fontWeight: " bold",
    fontSize: "1rem",
    marginBottom: "8px",
  },
  ownershipYear: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    width: "9rem",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  body2Text: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0",
    paddingBottom: "40px",
  },
  inputState: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  dataGridStyleForStaticData: {
    "& .MuiDataGrid-columnHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
    },
    "& .MuiDataGrid-columnHeaders .MuiDataGrid-withBorderColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      borderRight: "1px solid #a9cb83",
    },
    "& .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.MuiDataGrid-columnHeader--sorted.MuiDataGrid-withBorderColor":
      {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        backgroundColor: "#9dd262",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontFamily: CPSConstants.FONT_FAMILY as string,
          fontWeight: "bold",
        },
      },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {fontFamily: "Montserrat"},
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "flex",
      padding: "2px",
    },
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "bold",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "500",
      "& .MuiDataGrid-cell": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        padding: "5px 5px",
        lineHeight: "normal !important",
        whiteSpace: "normal !important",
        wordWrap: "break-word",
      },
    },
  },
  facultyBasicBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 0 0 5px",
  },
  paddingTop3: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    pt: 3,
  },
  paddingTop2: {
    pt: 2,
  },
  oneZeroAuto: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    flex: "1 0 auto",
  },
  paperPropDialogAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "40rem",
    minHeight: "15rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "35px !important",
    },
  },
  textAlignCenter: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "center",
    fontWeight: "bold",
  },
  stackPaddingTop: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    justifyContent: "center",
    paddingTop: "1rem",
  },
  facultyBasicSearchContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#EFEFEF",
    padding: "5px",
  },
  advanceSearchLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    paddingTop: "0.5rem",
  },
  advanceSearchResultAvatar: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "5rem",
    height: "auto",
    margin: "0% auto",
  },
  zeroTierheight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: 25,
  },
  uploadDocumentHeaderText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "left",
    paddingBottom: "1rem",
    color: "black",
    fontWeight: "bold",
  },
  uploadDocumentHeaderDesc: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "left",
    color: "black",
    fontWeight: "bold",
  },
  uploadDocumentBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "10px 0px",
  },
  formValidationFacultyProfile: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px 0 15px 0",
  },
  boxPaddingAlertStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0rem",
  },
  boxPadddingStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0.5rem",
  },
  spanStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
    fontWeight: "bold",
  },
  cursorPointer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
  },
  facultyProfileOnClickBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    color: "#486bbf",
    cursor: "pointer",
    padding: "5px 0px 5px 0",
  },
  ppqAdvanceSearchStack: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "20px 0 0 0",
  },
  hyperLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0000EE",
    cursor: "pointer",
  },
  calendarTemplateWrapBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#06f",
    textDecoration: "underline",
    cursor: "pointer",
  },
  calendarOnClickBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
    color: "#06f",
    padding: "5px 0",
    textDecoration: "underline",
    cursor: "pointer",
  },
  calendarTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid rgb(204, 204, 204)",
    width: "27rem",
  },
  calendarTableCellOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#CCFFCC",
    width: "10px",
  },
  calendarTableCellTwo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#96B8E9",
    width: "10px",
  },
  calendarTableCellThree: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFCCCC",
    width: "10px",
  },
  multiSelectSearchDropdownWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15rem",
  },
  multiSelectProgramFormats: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "12rem",
  },
  multiSelectSearchOwnerShipDropdownWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15.5rem",
  },
  multiSelectSearchMedicalConsultantDropdownWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "26.5rem",
  },
  ppqAdvanceSearchButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#233274",
    fontSize: "1rem",
    fontWeight: "bold",
    textTransform: "none",
  },
  textDecorationNone: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "none",
    cursor: "pointer",
  },
  borderSolidWhite: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "2px solid white",
  },
  columnBreakWord: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    whiteSpace: "normal",
    wordBreak: "break-word",
    lineHeight: "1.2",
    paddingTop: "0.313rem",
    paddingBottom: "0.313rem",
    fontWeight: "500",
  },
  cvbioText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    margin: "0 0 6px 0",
    padding: "4px 8px",
    background: "rgb(193, 234, 148)",
    color: "#fff",
  },
  avatarProfile: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    width: "80%",
    height: "80%",
    border: "1px solid #a9cb83",
    margin: "0 auto",
    "& .MuiAvatar-img": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      width: "80%",
      height: "80%",
      border: "1px solid #a9cb83",
      marginTop: "10px",
    },
  },
  faculyHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
    paddingRight: "5px",
  },
  tableBoxWrap: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "7px",
    paddingLeft: "7px",
    paddingBottom: "0px",
    paddingTop: "0px",
  },
  tableCellProfile: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "150px",
    borderRight: "#a9cb83 1px solid",
  },
  tableCellBgColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "rgb(193, 234, 148)",
  },
  tableCellHundrendPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
  },
  customTabPanelBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px 5px",
    border: "1px solid #a9cb83",
  },
  assistentAddress: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px 5px",
  },
  customTabContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    p: 2,
  },
  searchStatedropdown: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "white",
    "& .MuiSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px 8px",
    },
  },
  advanceSearchFormControl: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: 162,
  },
  advanceSearchMedicalStatus: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15rem",
  },
  boxFontStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1.4rem",
    fontWeight: "500",
    display: "flex",
    gap: "0rem",
    marginBottom: "0rem",
    marginleft: "0rem",
  },
  dataGridWrapper: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "auto",
    width: "100%",
    paddingTop: "1rem",
    display: "grid",
    gridTemplateColumns: "1fr",
  },
  facultyTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
  },
  typoGraphy: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
    textAlign: "left",
    fontWeight: "500",
    fontSize: "1rem",
  },
  viewListSubmitbtn: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "2rem",
    marginBottom: "2rem",
    display: "flex",
    justifyContent: "right",
  },
  viewListSubmitbtnWithBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "2rem",
    marginBottom: "2rem",
    display: "flex",
    justifyContent: "right",
    paddingTop: "10px",
  },
  facultyForm: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
    "& div": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      width: "100%",
      paddingRight: "8px",
    },
  },
  actionButtonInAdvanceSearch: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "1rem",
    display: "flex",
    justifyContent: "space-between",
    padding: "6px",
  },
  advanceFacultyDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    minHeight: "52rem",
  },
  advanceFacultyDialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px",
  },
  advanceFacultyDialogContentTableViewStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "15px",
    padding: "20px 24px",
  },
  deleteDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "30rem",
    padding: "0 0 10px 0",
  },
  deleteDialogContentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "22px !important",
  },
  deleteDialogActionStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  flexLeft: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "left",
  },
  flexEnd: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "end",
  },
  flexAlignEnd: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    alignContent: "center",
    display: "flex",
    justifyContent: "end",
  },
  facultyProfileScreeningInfo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "left",
    fontWeight: "bold",
  },
  closeIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    position: "absolute",
    right: 8,
    top: 8,
  },
  facultyHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
  },
  advanceSearchSubmitButtonStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "space-between",
  },
  advanceSearchDialogTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    p: "1.5rem",
    pl: "2rem",
    bgcolor: "#001444",
    color: "#ffffff",
  },
  dayCheckBoxStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0",
    margin: "0",
  },
  handleBackButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "10px",
  },
  pageSubHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.5rem 0.5rem 0.5rem 0.625rem",
    fontSize: "1.25rem",
    fontWeight: "bold",
    display: "flex",
    gap: "0.5rem",
  },
  contentSubHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.625rem",
    fontSize: "1rem",
    fontWeight: "bold",
    display: "flex",
    gap: "0.5rem",
    backgroundColor: "#C1EA94",
  },
  uploadSheeDialogBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "15px 20px 0 0",
  },
  uploadSheeDialogGridBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
  },
  advanceSearchSectionThreeFour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "40px 0 0 0",
  },
  fieldDocumentTypeColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    padding: "5px 15px 15px 5px",
  },
  advanceSearchBorderLeft: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderLeft: "2px solid #003",
    paddingLeft: "5px",
  },
  advanceSearchBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1.5px solid #003",
    width: "100%",
    margin: "10px 0 0 0px",
  },
  uploadFacultySheetBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "5px",
  },
  ppqgriditem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "0 !important",
  },
  expandSearch: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    alignItems: "center",
  },
  facultyAddNonHCPAndPatientContianerWithBackground: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    padding: "10px",
  },
  facultyAddNonHCPAndPatientContianer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "10px 0",
  },
  facultyAddNonHCPAndPatientDataGridContianer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "10px 0 10px 0",
  },
  facultyPotentialDuplicatesGridDialogMainContianer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "20px",
  },
  facultyPotentialDuplicatesGridDialogSubMainContianer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "10px",
  },
  facultyTextarea: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    padding: "5px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
  },
  facultyParentTextarea: {
    ".textArea-auto": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      resize: "none",
    },
  },
  approverInput: {
    ".approver-input input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "10px",
    },
  },
  facultyFormContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80%",
  },
  facultyValidationAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "1rem 0 1rem 0",
  },
  multipleSelectddl: {
    "& .MuiNativeSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "2px 0px 2px 2px !important",
      height: "94px!important",
    },
  },

  checkIsHCPBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "1rem",
    marginTop: "1.2rem",
  },
  checkIsHCPBoxRight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "1rem",
    marginTop: "1.2rem",
    marginLeft: "-10px",
  },
  checkIsHCPBoxFacultyType: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "1rem",
    fontWeight: "normal !important",
  },
  facultyHeaders: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#9cf",
  },
  facultyBoxBackground: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0.5rem",
    backgroundColor: "#f1fae6",
  },
  facultyBrandList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "0px 0 0 0",
  },
  facultyLeftMultipleItemList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  facultyRightMultipleItemList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
  },
  MultipleItemListButtonsBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    marginLeft: "0.75rem",
    marginRight: "0.75rem",
    justifyContent: "center",
  },
  backgroundHilighter: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFF",
  },
  backgroundHilighterIntroVideo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 6px",
  },
  facultyTextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "100%",
  },
  facultyWidth10Rem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "10rem",
  },
  facultyAddEditAddressTypography: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "200",
    marginBottom: "1rem",
    color: "black",
    display: "flex",
    justifyContent: "right",
    marginTop: "2rem",
  },
  boxGridCheckBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&.Mui-checked": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#9dd262",
    },
  },
  boxDDLValidation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0rem",
  },
  miscellaneousDialogValidation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0rem",
  },
  radioButtonStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "2px 9px",
  },
  boxDataGrid: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "auto",
    width: "100%",
    paddingTop: "0rem",
    display: "grid",
  },
  submitButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "right",
    marginTop: "1rem",
  },
  contractCustomTab: {
    minHeight: "30px",
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiButtonBase-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "4px",
      minWidth: "60px",
      minHeight: "30px",
    },
    ".MuiTabs-indicator": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "transparent",
    },
    ".Mui-selected": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 600,
    },
  },
  facultyTabsTittleContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px solid #d0d0d0",
    width: "100%",
    marginBottom: "15px",
  },
  viewLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  tabsCapitalize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "capitalize",
  },
  GridItemBgColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFFFFF",
    borderLeft: "2px solid white",
    borderRight: "2px solid white",
    padding: "8px 8px 8px 12px",
  },
  OrganizationalContact: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFFFFF",
    borderLeft: "2px solid white",
    borderRight: "2px solid white",
    padding: "0px 8px 8px 12px",
  },
  OrganizationalContactBox: {
    padding: "0 0 0 21px",
  },
  OrganizationalContactUl: {
    padding: "0 20px",
  },
  TableBgColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    borderTop: "#a9cb83 1px solid",
    border: "2px solid white",
    p: 1,
    "& td": {border: "2px solid white", fontFamily: "Montserrat"},
  },
  dataVerificationTrue: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "green",
  },
  dataVerificationFalse: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "gray",
  },
  dataVerificationIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    alignItems: "center",
    justifyCcontent: "space-between",
  },
  tabsSelected: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #a9cb83",
    "& .MuiTab-textColorPrimary": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      textTransform: "capitalize",
    },
    "& .Mui-selected": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000000 !important",
      fontSize: "1rem",
      textTransform: "capitalize",
    },
  },
  textBoxBgWhite: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "white",
  },
  tabDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#233274",
    height: 7,
    borderRadius: "5px 5px 0 0",
  },
  profileIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#bdbdbd",
    fontSize: "5rem",
  },
  flexCenter: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    padding: "15px 0 15px 0",
  },
  flexRight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
  },
  cvBioBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    fontWeight: "bold",
    padding: "5px 0px 5px 0",
    backgroundColor: "#9dd262",
  },
  fmvTierBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    padding: "5px 0px 5px 0",
    backgroundColor: "#9dd262",
    display: "block",
  },
  fmvTierBoxLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    textDecoration: "underline",
    color: "blue",
    fontSize: "0.9rem",
  },
  facultyBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    fontWeight: "bold",
    padding: "5px 0px 5px 0",
    backgroundColor: "rgb(193, 234, 148)",
  },
  avatarGridItem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderRight: "1px solid #a9cb83",
  },
  viewSpeakerTableCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#4aa0ff",
    border: "none",
    cursor: "pointer",
  },
  blueText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#4aa0ff",
    border: "none",
  },
  editTravelBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 7px",
  },
  selectControl: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFFFFF",
  },
  checkBoxControl: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiSvgIcon-fontSizeMedium": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#FFFFFF !important",
    },
  },
  typoGraphyHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
    textAlign: "left",
    fontWeight: "500",
    fontSize: "1.4rem",
  },
  containerBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "1rem",
  },
  mainContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "75%",
  },
  facultyProfileUploadDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "50rem",
    minHeight: "5rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropUploadDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "20rem",
    minHeight: "5rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  boxPaddingUploadAlertStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "0",
  },
  nameTrimmer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  imgStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "2.2rem",
  },
  multiSelectInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "14px",
    width: "480px",
    overflow: "hidden",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  mail1099SContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    lineHeight: "1.2",
    paddingTop: "0.313rem",
    paddingBottom: "0.313rem",
    fontWeight: "500",
  },
  mailing1099Box: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    lineHeight: "1.2",
    paddingTop: "0.313rem",
    paddingBottom: "0.313rem",
    fontWeight: "100",
  },
  addressTypeButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#090",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  fontWeightBold: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: 600,
  },
  fontWeightBoldText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
  },
  addressBtn: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#090",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  typographyFile: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "1.5rem",
    marginLeft: "0.5rem",
    color: "#000",
    fontWeight: "400",
  },
  reportMainContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85%",
    mt: "2rem",
  },
  editProfileMainContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80%",
    mt: "0",
  },
  inputFormControl: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "label + &": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      marginTop: 0,
    },
  },
  InstituationGridDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    padding: "10px",
    border: "1px solid #fff",
  },
  InstituationSkeletonGridDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #fff",
    marginBottom: "2px",
  },
  InstituationFormInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
  },
  bgE5F0FF: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#E5F0FF",
  },
  bgF0F9E5: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f0f9e5",
  },
  assistantInformationGridContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#E5F0FF",
    marginTop: "2rem",
  },
  marginRightOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: 1,
  },
  paddingTopThree: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    pt: 3,
  },
  assistantInformation: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "600",
    fontSize: "1.2rem",
    marginBottom: "1rem",
    color: "black",
  },
  tooltipIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "1px",
  },
  skeletonDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    height: "30px",
  },
  tableDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& tr:nth-child(even) ": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#ffffff",
    },
    "& th": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000",
      border: "1px solid rgb(169, 203, 131)",
      background: "#0E2079",
      fontWeight: "bold !important",
      fontSize: "1rem",
      padding: "6px 8px",
    },
    "& td": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid rgb(169, 203, 131)",
      fontWeight: "bold !important",
      fontSize: "1rem",
      padding: "6px 8px",
    },
  },
  facultyProfileImage: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20px",
    height: "20px",
  },
  commonTableCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "none !important",
    padding: "0 0 5px 0 !important",
    fontWeight: "bold !important",
  },
  tableCellGreen: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6 !important",
  },
  dataVerificationDetailsTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "90%",
    margin: "0 auto",
  },
  dataVerificationRow1: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20%",
  },
  dataVerificationRow2: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "30%",
  },
  dataVerificationRow3: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "30%",
  },
  dataVerificationRow4: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20%",
  },
  divTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "table",
    width: "100%",
  },
  divRow: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "table-row",
  },
  divcell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px grey solid !important",
    display: "table-cell",
    height: "20px",
    width: "25%",
    padding: "5px",
    verticalAlign: "middle",
    backgroundColor: "inherit",
  },
  marginLeftText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0.5rem",
  },
  addNonHcpTooltip: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "rgba(0, 0, 0, 0.87)",
    border: "5px solid lightgray",
    fontSize: 11,
  },
  textFieldPPQColorWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "95%",
  },
  paperPropTableReviewResultDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  paperPropPotentialAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "25rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "35px !important",
    },
  },
  paperPropProfileDataVerification: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "25rem",
    "& .MuiDialogContent-root": {
      p: "35px !important",
    },
  },
  masterContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "20px",
    "& input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
    marginLeft: "0px !important",
  },
  generalProfileMainBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0 20px",
    marginTop: "0.25rem !important",
    "& input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
    marginLeft: "0px !important",
  },
  addHCPProfileContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85%",
  },
  EditTravelProfileContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85%",
  },
  contatcInfoBoxContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0px 0",
  },
  CompensationContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "85%",
  },
  warningText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: 800,
    color: "red",
    lineHeight: 1.4,
  },
  normalText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: 800,
    lineHeight: 1.4,
  },
  facultyPrefrenceRadio: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px",
  },
  facultyPrefrenceRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "24px",
    "& span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 800,
    },
  },
  facultyProfileHeading: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "8px",
    paddingBottom: "3px",
    backgroundColor: "rgb(193, 234, 148)",
  },
  yesBoolean: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#0c3",
  },
  noBoolean: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
  },
  OptInContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& h6": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 600,
    },
    ".optInKey": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingRight: "15px",
    },
    ".subOptIn": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingRight: "20px",
      display: "flex",
    },
  },
  subradioGroup: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "1rem",
  },
  textFieldPPQColorFullWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "100%",
  },
  underLineTitle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".hcpsubheader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "flex",
    },
    ".hcpsubheader span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#0976D6",
      fontWeight: "bold",
      fontSize: "13px",
      paddingRight: "2px",
      paddingLeft: "2px",
    },
    ".subheaderline": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "23px",
    },
    ".left": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      position: "relative",
    },
    ".subheaderline span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      position: "absolute",
      height: "1px",
      backgroundColor: " #999999",
      marginTop: "10px",
      width: "100%",
    },
  },
  fullWithTextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "90%",
  },
  cancelRow: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "45px",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginTop: "8px",
    "& .MuiIconButton-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid black",
      borderRadius: 0,
      padding: "4px",
    },
  },
  facultyPrefrenceRadioLabelZeroMargin: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "0",
  },
  mainContainerBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderTop: "1px solid #9dd262",
  },
  addButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 12px",
    position: "relative",
    top: "-5px",
    textTransform: "capitalize",
  },
  addTextMessageAlertDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "60rem",
    padding: "0 0 10px 0",
  },
  contactNumberInputs: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& span": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      margin: "0 6px",
    },
    "& input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      width: "90%",
      padding: "4px",
    },
    "& fieldset": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      top: 0,
    },
    "& legend": {
      display: "none",
    },
  },
  borderThin: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "thin solid #3399FF",
  },
  borderNone: {
    border: "none",
  },
  addNewTierBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
  },
  displayFlex: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
  },
  addNewTierButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#090",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  facultyProfilefieldSet: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid #9dd262",
    width: "100%",
  },
  facultyProfileDivider: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px solid #9dd262",
  },
  textMessageAlertDialogUL: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& ul": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingLeft: "12px",
      margin: "0",
      fontWeight: "bold",
      fontSize: "11px",
    },
    "& li": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingLeft: "10px",
      paddingBottom: "12px",
    },
  },
  textMessageAlertActionStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  flexJustifyCenter: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  flexSpaceBetween: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "space-between",
  },
  addTopicInfoDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80rem",
    maxWidth: "80rem",
    padding: "0 0 10px 0",
  },
  paperPropDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "55rem",
    minHeight: "10rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  screeningDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "5px 0px 0 0",
    fontStyle: "italic",
  },
  stackFormCenterButton: {
    // Button align using @mui stack
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  Redlabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
    fontWeight: " bold",
    paddingBottom: "4px",
  },
  Defaultlabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "black",
    fontWeight: " bold",
    paddingBottom: "4px",
  },

  paddingBottom4: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "4px",
  },
  paddingRightZeroFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    pr: 0.5,
  },
  fieldPlacement: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "10px !important",
  },
  input: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.531rem 0.625rem !important",
      fontSize: "1rem",
    },
  },
  facultyInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  facultyInputApprover: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "normal",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  facultyGroupSize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    width: "12rem",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  activityGridStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "flex-end",
    padding: "0 0.625rem",
  },
  travelNatioalWideRadioGroup: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
  },
  taxFormAdditionalTableContainerStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50%",
    paddingTop: "2rem",
  },
  taxFormAdditionalTableHeaderStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    backgroundColor: "#9dd262",
  },
  taxFormAdditionalTableBodyStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
  },
  taxFormAdditionalTablecellStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50%",
    padding: "0.313rem",
  },
  btnPlaceEvenly: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    paddingTop: "1rem",
  },
  addedByText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  taxFormRadioGroupStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.5rem 0.1rem 0.25rem 0.25rem",
  },
  taxFormDescription: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bolder",
    padingLeft: "2px,",
  },
  optionLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiFormControlLabel-label": {fontWeight: "bold"},
  },
  taxFormPageHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: "1.5rem",
    borderBottom: "2px solid #87CEEB",
  },
  taxFormUploadBtn: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "1rem",
    textAlign: "right",
  },
  approvedTextStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "green",
  },
  gridItemsPadding: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "1rem 1rem 1rem 0",
  },
  colorRed: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
  },
  reqlabelStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "red",
    fontWeight: "bold",
  },
  taxFormDialogSubHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "rgba(0, 0, 0, 0.87)",
    fontWeight: "bold",
    backgroundColor: "#C1EA94",
    padding: "0.5rem",
    marginTop: "2rem",
  },
  paperPropsViewAttachDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    minHeight: "45rem",
  },
  centerTheDialogContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  iframeContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "90rem",
    height: "40rem",
    width: "100%",
  },
  FacultyMiscellaneousGridDesignColorBg: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#FFFFFF",
    padding: "8px",
  },
  FacultyMiscellaneousGridDesign: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "8px",
  },
  addEditNewScheduleDialogStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "60rem",
    maxWidth: "60rem",
    padding: "0 0 10px 0",
  },
  addTrainingInfoStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "80rem",
    maxWidth: "80rem",
    padding: "0 0 10px 0",
  },
  hideDatePckerIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiInputAdornment-positionEnd": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "none",
    },
  },
  paperTravelDocumentUploadDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "35rem",
    minHeight: "5rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  travelDocumentsIconsList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "2px",
  },
  customOptInStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiFormHelperText-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: 800,
      fontSize: "0.9rem",
      marginLeft: "2px",
    },
  },
  selectorDisabledStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&.Mui-disabled": {display: "none"},
  },
  contactInfoFormLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500",
    fontSize: "1.5rem",
  },
  facultyCVBioRow: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
    padding: "1rem",
    marginLeft: "0px !important",
    width: "100% !important",
  },
  facultyCVBioNormalText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: 800,
    fontSize: "0.95rem",
    paddingBottom: "6px",
    // lineHeight: 1.4,
  },
  facultyCVBioRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiFormControlLabel-label": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      marginRight: "0",
      fontWeight: 800,
      fontSize: "0.95rem",
    },
  },
  datePckerPaddingIcon: {
    ".MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingRight: "0",
      width: "70%",
    },
    ".MuiOutlinedInput-root input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.4rem",
    },
  },
  facultyCVBioSelect: {
    "& .MuiOutlinedInput-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "4.5px 6px",
    },
  },
  facultyCVBioCheckBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiCheckbox-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "4px",
    },
  },
  subradioGroupZeroPadding: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0",
  },
  facultySpeakerProgramPrefrenceRadioLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginRight: "24px",
  },
  facultySpeakerProgramPreferencesRow: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".speakerProgramPreferencesBgColor": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      display: "inline-block",
      width: "100%",
    },
  },
  cancelRowPreference: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "25px",
    "& .MuiIconButton-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid black",
      borderRadius: 0,
      padding: "0.4rem",
      marginRight: "0.4rem",
    },
  },
  brandsTableStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiGrid-item": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid #b4b4b4",
      padding: "0.5rem",
    },
  },
  floatSPPs: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    float: "left",
  },

  EditProfileCredList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "0 0 0 0",
    width: "46%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
  },
  EditProfileCheckbox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "1rem",
    marginTop: "1rem",
  },
  paperPropTableDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    minHeight: "45rem",
    "& .MuiDialogContent-root": {
      p: "20px !important",
    },
  },
  mainTableStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    margin: "10px 0 0 0",
    width: "100%",
  },
  TableHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "rgb(193, 234, 148) !important",
    "& tr": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px",
    },
    "& th": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#000 !important",
      border: "1px solid rgb(169, 203, 131)",
      fontWeight: "bold",
      fontSize: "1rem",
      padding: "8px",
    },
    "& td": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: "bold !important",
    },
    fontWeight: "bold",
    fontSize: "1rem",
  },
  DataVerficationCriteriaText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500",
    fontSize: "1rem",
  },
  EditPPQText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500",
    fontSize: "1rem",
  },
  DatePicker: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    minWidth: "300px",
    height: "50px",
    "& .MuiOutlinedInput-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px 8px",
    },
    background: "#FFFFFF",
  },
  dropdown: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15rem",
    minWidth: "10rem",
    "& .MuiSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px 8px",
    },
    background: "#FFFFFF",
  },
  paperPropExpenseDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "55rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "10px !important",
    },
  },
  paperPropPPQEditDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "55rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "10px !important",
    },
  },
  editPPQDataLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
  },
  editProfileButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "primary",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  editProfileSendButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "primary",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
    ml: "10px",
  },
  editProfileSubmit: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  editProfileLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500 !important",
    padding: "0.5rem",
  },
  editProfileBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
  },
  editProfileBoxContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "left",
    paddingTop: "1rem",
  },
  editProfileCantFindText: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500 !important",
  },
  editProfileCantFindLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold !important",
  },
  dataVerificationGrid: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1rem",
  },
  dataVerificationPaperProps: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "40rem",
    minHeight: "20rem",
  },
  DatePickerDOB: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    "& .MuiOutlinedInput-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px 8px",
    },
    "& .MuiInputBase-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
    background: "#FFFFFF",
  },
  SSN1TextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "10rem",
  },
  SSN2TextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "9rem",
  },
  SSN3TextField: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    width: "11rem",
  },
  ppqSection: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
  },
  GridColumnWithIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    lineHeight: "1.2",
    paddingTop: "0.313rem",
    paddingBottom: "0.313rem",
    fontWeight: "500",
  },
  menuBookIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
    gap: "0.2rem",
  },
  expenseExpGrid: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "1",
    marginTop: "1rem",
    backgroundColor: "#9dd262",
  },
  expAddButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#090",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  ssnBox: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    rowGap: "0.2rem",
  },
  yearDDL: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    bgcolor: "#FFFFFF",
    maxwidth: "5rem",
    maxHeight: "2rem",
  },
  compTableRow: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&. MuiTableRow-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "10px",
    },
  },
  FacultyAllocationContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
    marginTop: "20px !important",
  },

  BoxContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
    paddingTop: "1rem",
  },
  AlertStack: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "58%",
    mt: "1rem",
    "& .MuiAlert-icon": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "5px 0",
    },
    "& .MuiAlert-standardError": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
    "& .MuiAlert-standardInfo": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
    "& .MuiAlert-standardSuccess": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
    "& .MuiAlert-standardWarning": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      alignItems: "center",
      padding: "0 10px !important",
    },
  },
  AllocationAlert: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  Link: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#9dd262",
    cursor: "pointer",
  },
  formLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500",
  },
  popOutButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    color: "#090",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  InfoIconStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0.5rem",
  },
  muiLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "none",
    cursor: "pointer",
  },
  orgFormLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "800",
    padding: "0.5rem",
  },
  editAddButton: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "#090",
    border: "1px solid #090",
    textTransform: "none",
    fontWeight: "bold",
  },
  font500: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "500",
    padding: "0.5rem",
  },
  dataVerificationLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1",
    cursor: "pointer",
  },
  containerHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "1",
    marginTop: "1rem",
    backgroundColor: "#9dd262",
  },
  menuItem: {fontFamily: "Montserrat"},
  boxIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    gap: "10px",
  },
  justifyFlexRight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "right",
  },
  stack: {fontFamily: CPSConstants.FONT_FAMILY as string, flex: "1 0 auto"},
  allocationTableCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#9dd262",
    border: 1,
  },
  border: {border: 1},
  allocationTableCellwithMaxWidth: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: 1,
    maxWidth: "9rem",
  },
  allocationPaper: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "35rem",
    minHeight: "20rem",
  },
  allocationRulePaper: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    minHeight: "45rem",
  },
  affilLicenPageHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  affilLicenPagesubHeader: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: "1.25rem",
    paddingTop: "0.75rem",
    borderBottom: "2px solid #87CEEB",
  },
  topHeaderInfo: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "normal",
  },
  topHeaderInfoDanger: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "normal",
    color: "Red",
  },
  backGroundColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
  },
  contentHeaderWithBackground: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "10px",
    fontSize: "1rem",
    fontWeight: "bold",
    display: "flex",
    gap: "0.5rem",
    backgroundColor: "#C1EA94",
  },
  gridLeftCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.313rem",
    borderTop: "1px solid black",
    borderLeft: "1px solid black",
  },
  gridRightCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.313rem",
    borderTop: "1px solid black",
    borderRight: "1px solid black",
    borderLeft: "1px solid black",
  },
  gridLeftBottomCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.313rem",
    borderTop: "1px solid black",
    borderLeft: "1px solid black",
    borderBottom: "1px solid black",
  },
  gridRightBottomCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.313rem",
    border: "1px solid black",
  },
  marginLeftAuto: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "auto",
  },
  buttonPaddingBottom: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0.5rem",
  },
  widthHundrendPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "100%",
  },
  paddingPointTwoFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.25rem",
  },
  paddingLeftPointFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0.5rem",
  },
  marginBottomPointFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "0.5rem",
  },
  fontWeightSixHundred: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: 600,
  },
  paddingTopPointSixTwoFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "0.625rem",
  },
  marginTopOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "1rem",
  },
  paddingTopPointFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "0.5rem",
  },
  richTextEditorHeight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "16rem",
  },
  iconPadding: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0.313rem",
  },
  paddingLeftPointSixTwoFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0.625rem",
  },
  mapContainerStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "25rem",
    marginTop: "1rem",
    borderRadius: "5px",
    marginRight: "1rem",
    marginLeft: "0.625",
  },
  typography: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "white",
    fontSize: 13,
    position: "absolute",
    top: "38%",
    right: "50%",
    transform: "translate(50%, -50%)",
    borderRadius: "50%",
    padding: "0.125rem 0.375rem",
  },
  iconContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
  },
  displayInline: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "inline",
  },
  addRemoveButtonBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px solid black",
  },
  paddingBottomOne: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "1rem",
  },
  marginBottomFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginBottom: "5rem",
  },
  licenseDeleteDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "38rem",
    padding: "0 0 10px 0",
  },
  affiliationDataGridContianer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "10px 0 10px 0",
    minHeight: "10rem",
  },
  pictureIcon: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
    paddingLeft: "2px",
  },
  textDecorationHover: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "&:hover": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      textDecoration: "underline",
    },
  },
  textDecorationNoneWithUnderHoverATag: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    a: {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      color: "#1976d2",
      fontSize: "1rem",
      textDecoration: "none",
      cursor: "pointer",
      "&:hover": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        textDecoration: "underline",
      },
    },
  },
  facultyTabLinkFontSize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
  },
  facultyTabBoldLinkFontSize: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "bold !important",
  },
  facultyTrainingRequirementsTables: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .facultyTrainingRequirementsCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontWeight: "bold !important",
    },
    "& .facultyTrainingRequirementsHeader": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& .MuiBox-root": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        fontWeight: "bold !important",
      },
    },
  },
  paperPropFacultyTrainingRequirements: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "70rem",
    minHeight: "25rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "35px !important",
    },
  },
  avtivityStatsLinkStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "unset",
  },
  tabsContAndTrainingCustom: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "1.5rem !important",
    position: "relative",
    "&:after": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      content: "''",
      position: "absolute",
      top: "14px",
      right: "4px",
      width: "3px",
      height: "3px",
      backgroundColor: "#050505",
      borderRadius: "50%",
    },
    ":last-child::after ": {display: "none"},
  },
  venueCatererMultiSelectInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    paddingRight: "14px",
    width: "100%",
    overflow: "hidden",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  inputFieldBackgroundColour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.625rem !important",
    backgroundColor: "#ffff",
  },
  contactNotesFieldBackgroundColour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.625rem !important",
    backgroundColor: "#f1fae6",
  },
  detailsBackgroundColour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    backgroundColor: "#f1fae6",
  },
  paperPropBILimitDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "80rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      p: "20px !important",
    },
  },
  paperPropContactInfoDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "95rem",
    minHeight: "40rem",
    "& .MuiDialogContent-root": {
      p: "20px !important",
    },
  },
  biCompDivs: {
    backgroundColor: "#abcefc",
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "2rem",
    borderRadius: "1rem",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0.2rem",
      backgroundColor: "#fff",
    },
  },
  facultyViewNotesDiv: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "1.5rem",
  },
  viewNotesTopBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderTop: "1px solid #c5c5c5",
    paddingTop: "1.5rem",
  },
  paperPropViewNotesDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "65rem",
    minHeight: "50rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  viewNotesTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& thead": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "rgb(193, 234, 148) !important",
      "& tr th": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "1px solid rgba(224, 224, 224, 1)",
        fontWeight: "bold",
        fontSize: "1rem",
        padding: "0.2rem",
      },
    },
    "& tbody": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& tr th": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "1px solid rgba(224, 224, 224, 1)",
        fontWeight: "bold",
        color: "#000",
        fontSize: "1rem",
        padding: "0.3rem",
      },
      "& tr td": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "1px solid rgba(224, 224, 224, 1)",
        fontWeight: "bold",
        color: "#000",
        fontSize: "1rem",
        padding: "0.3rem",
      },
    },
  },
  viewNotesTotalTable: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#9dd262",
    "& thead": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& tr th": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        border: "1px solid rgba(224, 224, 224, 1)",
        fontWeight: "bold",
        fontSize: "1rem",
        padding: "0.2rem",
      },
    },
  },
  tableFixedCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "200px",
  },
  tableFixedTotalCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "95px",
  },
  myListFormInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiInputBase-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      paddingRight: "0 !important",
    },
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
      border: "1px solid #767676",
    },
  },
  compGridCaption: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#a9cb83",
    display: "flex",
    alignItems: "center",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
  },
  compTotalBackground: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#8dacfa",
  },
  gridTotal: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "right",
    paddingRight: "0.76rem",
  },
  gridTotallabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    color: "white !important",
  },
  backGroundColorWhite: {
    backgroundColor: "#fff",
  },
  iconHtWd: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "20px",
    height: "20px",
  },
  textCenter: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlign: "center",
    width: "100%",
  },
  dataTableStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiTable-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid #a9cb83",
    },
    "& .MuiTableHead-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#C1EA94",
    },
    "& .MuiTableCell-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      border: "1px solid #a9cb83",
      padding: "5px 5px",
      lineHeight: "normal !important",
      whiteSpace: "normal !important",
      wordWrap: "break-word",
    },
    "& .MuiTableBody-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      backgroundColor: "#fff",
    },
  },
  displayInlineBlock: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "inline-block",
  },
  customAutoCompeleteStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".MuiInputBase-root-MuiInput-root::before": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      border: "1px solid rgb(196 196 196)  !important",
      left: "0",
      bottom: "0",
      position: "absolute",
      right: "0",
      pointerEvents: "none",
      padding: "10px !important",
      borderRadius: "4px !important",
    },
    ".MuiAutocomplete-root .MuiInput-root .MuiInput-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "0px 4px 10px 8px !important",
    },
    ".MuiAutocomplete-endAdornment": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      position: "absolute",
      right: "1% !important",
      top: "40% !important",
    },
    ".MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before":
      {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderBottom: "1px solid #c4c4c4 !important",
      },
  },
  helpDialogTwoIcons: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "4rem",
    height: "2rem",
  },
  helpDialogthreeIcons: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "5.75rem",
    height: "2rem",
  },
  helpDialogfourIcons: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "8rem",
    height: "2rem",
  },
  helpDialogfiveIcons: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "10rem",
    height: "2rem",
  },
  marginTopPointFive: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginTop: "0.5rem",
  },
  customCheckBoxSSP: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    ".customSSP": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "5px 9px 4px 9px !important",
    },
  },
  disabledLink: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textDecoration: "underline",
    cursor: "pointer",
  },
  dataVerifiationCellStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  dataVerifiationLastCellStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px #9dd262 solid",
  },
  paddingLeftPointThree: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0.3rem",
  },
  dataVerificstionBorderLeft: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderLeft: "1px #9dd262 solid",
  },
  dataVerificstionBorderRight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderRight: "1px #9dd262 solid",
  },
  editProfileMultiSelectInput: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: " bold",
    paddingRight: "14px",
    width: "100%",
    overflow: "hidden",
    "& .MuiInputBase-input": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8.5px 10px !important",
      fontSize: "1rem",
    },
  },
  speakerProgramRightFirstRowStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #9dd262 solid",
  },
  speakerProgramRightCellStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderLeft: "1px #9dd262 solid",
  },
  speakerProgramLastCellStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px #9dd262 solid",
    borderLeft: "1px #9dd262 solid",
    borderRight: "1px #9dd262 solid",
  },
  speakerProgramBottomBorderStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "1px #9dd262 solid",
  },
  speakerProgramCenterRowStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #9dd262 solid",
    borderLeft: "0px",
  },
  paddingBottomPointnine: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0.9rem",
  },
  speakerProgramCellHeight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    height: "2rem !important",
  },
  paddingBottomZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingBottom: "0px",
  },
  paddingZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0",
  },
  speakerProgramCellAlignmentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center",
    justifyContent: "center",
    paddingRight: "0",
  },
  speakerProgramLabelCellAlignmentStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexWrap: "wrap",
    alignContent: "flex-start",
    justifyContent: "center",
    paddingRight: "0",
  },
  speakerProgramTopBorderStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderTop: "1px #9dd262 solid",
  },
  marginLeftZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    marginLeft: "0",
  },
  firstRowStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #9dd262 solid",
  },
  borderLeftStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderLeft: "1px #9dd262 solid",
  },
  borderRightStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderRight: "1px #9dd262 solid",
  },
  otherCellBorder: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    border: "1px #9dd262 solid",
    borderTop: "0",
  },
  cellWithBorder: {
    border: "1px #9dd262 solid",
  },
  widthtenRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "10rem",
  },
  box: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    minWidth: "600px",
    height: "50px",
  },
  rffdropdown: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "25rem",
    minWidth: "10rem",
    "& .MuiSelect-select": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      padding: "8px 8px",
    },
    background: "#FFFFFF",
  },
  compensationGrid: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "18rem",
    background: "#C1EA94",
    fontSize: "inherit",
    fontWeight: "bold",
  },
  compensationBlankCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#ffff",
    border: "0px !important",
  },
  tableCellBackgroundColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#C1EA94",
  },
  copensationTotalRowColor: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    background: "#9dd262",
    fontWeight: "bold",
    padding: "6px 0px",
    fontSize: "inherit",
  },
  downloadToExcelStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    cursor: "pointer",
    padding: "0",
  },
  compensationCardLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "1rem",
    fontWeight: "bold",
  },
  compensationCardFieldLabel: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
  },
  gapOneRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    gap: "1rem",
  },
  gapTwoRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    gap: "2rem",
  },
  gapFourRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    gap: "4rem",
  },
  componsationBorderRight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    justifyContent: "flex-end",
    paddingRight: "0.5rem",
    textAlignLast: "end",
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  widthFifteenRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "15rem",
  },
  textAlignLast: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textAlignLast: "end",
  },
  componsationHeaderCells: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    justifyContent: "flex-end",
    paddingRight: "0.5rem",
    textAlignLast: "end",
  },
  componsationUnspecifiedHeaderCells: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    justifyContent: "flex-end",
    textAlignLast: "end",
  },
  borderBottomZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderBottom: "0",
  },
  brandAllocationBorderRight: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  widthFiftyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "50%",
  },
  fontInherit: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "inherit",
  },
  screeningProfileHeaderStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    padding: "0.313rem 0 0.313rem 0.313rem",
  },
  allocateFundsButtonStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    textTransform: "none",
    fontSize: "1rem",
  },
  mailTextContainer: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    wordWrap: "break-word",
    overflowWrap: "break-word",
    width: "100%",
  },
  widthFourtyPercent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "40%",
  },
  uploadFileTextfieldStyles: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiOutlinedInput-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      "& input": {
        paddingLeft: "0px",
        fontFamily: CPSConstants.FONT_FAMILY as string,
      },
      "& fieldset": {
        border: "none",
        fontFamily: CPSConstants.FONT_FAMILY as string,
      },
    },
  },
  verifiedDataLinkStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "block",
    justifyContent: "center",
    color: "#1919ff",
    cursor: "pointer",
    padding: "5px 0px 5px 0",
    textDecoration: "underline",
  },
  paddingTopOneRem: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingTop: "1rem",
  },
  paddingLeftZero: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingLeft: "0",
  },
  opacityPointFour: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    opacity: 0.4,
  },
  marginTopThreePointSixTwoFiveRem: {
    marginTop: "3.75rem",
  },
  tableCellCompLimit: {width: "16rem"},
  tableCellUnspecifiedDollers: {width: "17rem"},
  tableCellUsed: {width: "0.2rem"},
  compTableRowName: {width: "15rem", background: "#C1EA94"},
  compTableTotalRow: {height: "1rem", background: "#9dd262"},
  compTableCell: {width: "15rem", color: "white !important"},
  totalCompLimitRow: {height: "1rem", background: "#9dd262"},
  heightOneRem: {height: "1rem"},
  fontFamilyStyles: {
    fontFamily: `${CPSConstants.FONT_FAMILY} !important`,
  },
  compensationGridCell: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: "inherit",
  },
  facultyAllocationTableHeader: {
    lineHeight: "1.2",
    paddingTop: "0.313rem",
    paddingBottom: "0.313rem",
    fontWeight: "500",
    paddingRight: "0.1rem",
  },
  textSecondary: {
    color: "text.secondary",
  },
  widthTenRem: {
    width: "10rem",
  },
  facultyProfileList: {
    paddingLeft: "1.5rem",
    margin: "3px",
  },
  widthNinetyPercent: {
    width: "90%",
  },
  verticalAlignBottom: {
    verticalAlign: "bottom",
  },
  justifyContentLeft: {
    justifyContent: "left",
  },
  facultyProfileGridHeight: {
    height: "calc(100% - 2.5rem)",
  },
  heightHundredPercent: {
    height: "100%",
  },
  medicalStartDate: {
    padding: "0 10px",
    margin: "-8px -2px",
  },
  facultyCalendarDivider: {
    borderColor: "#a9cb83",
    padding: "2px 0",
  },
  calendarAlertPadding: {
    padding: "10px 0px",
  },
  pdfDocumentsIconsList: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    paddingRight: "4px",
  },
};
